import { Menu } from '@chakra-ui/react';
import { useContextMenu } from './context';

export interface ContextMenuTriggerProps<T> extends Menu.ContextTriggerProps {
  data?: T;
}

export const ContextMenuTrigger = memo(function ContextMenuTrigger<T>({
  data,
  ...props
}: ContextMenuTriggerProps<T>) {
  const { setData } = useContextMenu();
  const onContextMenu = useCallback(() => {
    setData(data);
  }, [data, setData]);

  return (
    <Menu.ContextTrigger
      as="div"
      userSelect="inherit!important"
      {...props}
      onContextMenu={onContextMenu}
    ></Menu.ContextTrigger>
  );
});
